<template>
    <DsModal
        id="campaign-builder-goal-modal"
        class="goal-modal"
        :is-open="isOpen"
        :dialog="dialog"
        :show-close="showClose"
        :size="size"
        :title="title"
        @close="close"
    >
        <template #header>
            <DsFilledButton
                data-qa="goal-modal-save-button"
                :disabled="!showSave"
                @click="save"
            >
                <template #default>
                    {{ actionButtonLabel }}
                </template>
                <template v-if="actionButtonTrailingIcon" #trailing>
                    <DsIcon :name="actionButtonTrailingIcon" />
                </template>
            </DsFilledButton>
        </template>

        <template #default>
            <DsInlineAlert
                v-if="showWarning"
                class="modal-warning"
                data-qa="goal-modal-warning-alert"
                :type="alertType"
                leading-icon
            >
                {{ warningText }}
            </DsInlineAlert>
            <div v-if="showSummaryText" class="goal-summary">
                <div class="goal-summary-label">
                    {{ summaryLabel }}
                </div>

                <div class="goal-summary-text">
                    {{ summaryText }}
                </div>
            </div>

            <div :class="{ 'goal-configuration': showSummaryText}">
                <slot name="goalParameters" />
            </div>

            <div v-if="goalTipText" class="goal-tip">
                <div class="goal-tip-icon">
                    <DsIcon name="info-circle" />
                </div>

                <div class="goal-tip-text">
                    {{ goalTipText }}
                    <div>
                        <DsFilledButton
                            v-if="goalTipLink"
                            class="goal-tip-button"
                            as="a"
                            :href="goalTipLink"
                            target="_blank"
                            trailing-icon="external-link"
                        >
                            <div>
                                {{ goalTipButtonLabel }}
                            </div>
                        </DsFilledButton>
                    </div>
                </div>
            </div>
        </template>
    </DsModal>
</template>

<script>
export default {
    props: {
        actionButtonLabel: {
            type: String,
            default: 'Save',
        },
        actionButtonTrailingIcon: {
            type: String,
            default: '',
        },
        goalTipButtonLabel: {
            type: String,
            default: 'Learn more',
        },
        summaryLabel: {
            type: String,
            default: 'Summary',
        },
        isOpen: {
            type: Boolean,
            required: true,
        },
        dialog: {
            type: Boolean,
            default: true,
        },
        goalTipLink: {
            type: String,
            default: '',
        },
        goalTipText: {
            type: String,
            default: '',
        },
        size: {
            type: String,
            default: 'med',
        },
        showClose: {
            type: Boolean,
            default: true,
        },
        showSave: {
            type: Boolean,
            default: true,
        },
        summaryText: {
            type: String,
            default: '',
        },
        title: {
            type: String,
            required: true,
        },
        showWarning: {
            type: Boolean,
            default: false,
        },
        alertType: {
            type: String,
            default: 'critical',
        },
        warningText: {
            type: String,
            default: '',
        },
    },
    emits: ['close-modal', 'update-config'],
    computed: {
        showSummaryText() {
            return !!this.summaryText;
        },
    },

    methods: {
        close() {
            this.$emit('close-modal');
        },

        save() {
            this.$emit('update-config');
        },
    },
};
</script>
<style lang="scss">
#campaign-builder-goal-modal.goal-modal .modal-body {
    padding: 0;
}

#campaign-builder-goal-modal.goal-modal .modal-dialog.med.dialog {
    min-height: auto;
}
</style>

<style lang="scss" scoped>
.goal-summary-text {
    margin-top: 4px;
    line-height: 1.5;
}

.goal-summary-label {
    font-size: 12px;
    color:      $color-ink-800;
}

.goal-configuration {
    margin: 24px 0 0 0;
}

.goal-tip {
    display:            flex;
    padding:            12px;
    border-radius:      8px;
    flex-wrap:          wrap;
    justify-items:      left;
    background-color:   $color-blue-050;
}

.goal-tip-icon {
    flex:   6%;
    color:  $color-blue-300;
}

.goal-tip-text {
    margin-top: 2px;
    flex:   94%;
    color:  $color-ink-900;
}

.goal-tip-button {
    height:             32px;
    margin-top:         8px;
    padding:            8px 12px 8px 8px;
    border-radius:      8px;
    color:              $color-ink-900;
    background-color:   $color-ink-100;
}

.modal-warning {
    margin-top: -$spacing-200;
    display: flex;
    width: 100%;
    margin-bottom: $spacing-500;
}
</style>
